/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
 */

import { getBrowserDetails } from '../../../util/environment.js';
import { preventedShortcuts } from './shortcuts.js';

const platforms = Object.freeze({
    win: 'win',
    mac: 'mac'
});

/**
 * Get the list of unique shortcuts applicable to the current platform (OS)
 * @param {object[]} whitelist the array of whitelisted shortcuts
 * @returns {object[]} shortcuts
 */
export function getPlatformShortcuts(whitelist = []) {
    const { os } = getBrowserDetails(window.navigator.userAgent);

    let osPlatform;
    if (os?.name?.includes('win')) {
        osPlatform = platforms.win;
    } else if (os?.name?.includes('mac')) {
        osPlatform = platforms.mac;
    }

    const isInWhitelist = (shortcutItem, platform) =>
        whitelist.some(
            whitelistItem =>
                whitelistItem.shortcut === shortcutItem.shortcut &&
                (typeof whitelistItem.platform === 'undefined' ||
                    typeof platform === 'undefined' ||
                    whitelistItem.platform === platform)
        );

    const shortcuts = preventedShortcuts.filter(item => {
        if (isInWhitelist(item, osPlatform)) {
            return false;
        }
        return osPlatform ? item.platform === osPlatform : true;
    });

    // Build a collection of `shortcut` objects with distinct shortcut values
    return [...new Map(shortcuts.map(item => [item['shortcut'], item])).values()];
}
